import React, { Component } from 'react';
import {
    Toast
} from 'antd-mobile';
class ticketPage extends Component{
    
    constructor(props) {
        super(props)
        this.state = {
            telephone: '',
            ticket: ''
        }
    }
    componentDidMount() {
        const searchParams = new URLSearchParams(window.location.search)
        this.setState({
            telephone: searchParams.get('telephone') || '',
            ticket: searchParams.get('ticket') || ''
        })
        if (searchParams.get('ticket')) {
            this.jumpBindingStudent(searchParams.get('ticket'))
        } else {
            Toast.show({
                content: '参数错误',
            })
        }
    }
    // 跳转至趣智后勤热水
    jumpBindingStudent = (val) => {
        this.props.history.push(`/bindingStudent?ticket=${val}`)
        // this.props.history.push('/cardRechargeInfo?rechargeMoney='
        //                 + rechargeMoney + '&userId=' + userId + '&projectId=' + projectId +
        //                 '&organizationName=' + CampusPayInformation.organizationName + '&telPhone=' + telPhone
        //                 + '&payWay=' + payWay + '&loginCode=' + loginCode + '&accountId=' + accountId)
    }
    render() {
        return (
            <>
                <div className='page-box'>
                </div>
            </>
        )
    }
}

export default ticketPage;